import { createRoot } from "react-dom/client";
import "./style.css";
import { App } from "./App";
import { start } from "./live";
import { keepBadge } from "./notify";
import { go, parseUrl, useStore } from "./store";
import { startDesktop } from "./desktop";
import { toast } from "./components/ui";

useStore.setState({ route: parseUrl(location.pathname) });
keepBadge();
startDesktop((path) => go(parseUrl(path)), toast);
start();
createRoot(document.getElementById("root")!).render(<App />);
